var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-container",attrs:{"id":"EmptyContent"}},[_c('img',{staticStyle:{"width":"90px","height":"90px"},attrs:{"src":_vm.img,"alt":""}}),_c('i',{staticClass:"ft-grey"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }